import { render, staticRenderFns } from "./EstablishmentStateAnswerTextValidation.vue?vue&type=template&id=f2f5f0cc&scoped=true&"
import script from "./EstablishmentStateAnswerTextValidation.vue?vue&type=script&lang=js&"
export * from "./EstablishmentStateAnswerTextValidation.vue?vue&type=script&lang=js&"
import style0 from "./EstablishmentStateAnswerTextValidation.vue?vue&type=style&index=0&id=f2f5f0cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f5f0cc",
  null
  
)

component.options.__file = "EstablishmentStateAnswerTextValidation.vue"
export default component.exports